import { UserOutlined } from '@ant-design/icons'
import { Avatar, Divider, Flex } from 'antd'
import { useTheme } from 'antd-style'

import { GetUserProfileResponse } from 'src/api/requests'
import { CalendarIcon, CallIcon, LogoutIcon, SMSIcon } from 'src/assets'
import { DetailsItem, Text } from 'src/components'
import { useSessionContext } from 'src/contexts'
import { formatDate } from 'src/libs'
import { useLocales } from 'src/locales'
import { formatIdnp } from 'src/utils'

import { useStyles } from './styles'

type Props = {
  data?: GetUserProfileResponse
}

export const ProfileDetails = ({ data }: Props) => {
  const { styles } = useStyles()
  const palette = useTheme()
  const { t } = useLocales()
  const { onLogout } = useSessionContext()

  return (
    <div className={styles.userDetails}>
      <Flex vertical gap={12} align="center">
        <Avatar size={120} className={styles.avatar}>
          <UserOutlined />
        </Avatar>

        <Flex vertical align="center">
          <Flex gap={8} align="center">
            <Text weight={600} size="xxl">
              {data?.firstName} {data?.lastName}
            </Text>
          </Flex>

          {data?.idnp && (
            <Text color={palette.grey.grey1}>
              {t('form.idnp')}: {formatIdnp(data.idnp)}
            </Text>
          )}
        </Flex>
      </Flex>

      <Divider className={styles.divider} />

      <Flex vertical gap={8}>
        {data?.dateOfBirth && (
          <DetailsItem
            icon={<CalendarIcon />}
            detail={formatDate(data.dateOfBirth)}
          />
        )}

        {data?.phoneNumber && (
          <DetailsItem
            icon={<CallIcon className={styles.icon} />}
            detail={data.phoneNumber}
          />
        )}

        {data?.email && <DetailsItem icon={<SMSIcon />} detail={data?.email} />}
      </Flex>

      <Divider className={styles.divider} />

      <Flex
        align="center"
        justify="space-between"
        className={styles.logout}
        onClick={onLogout}
      >
        <Text weight={500}>{t('auth.logout')}</Text>

        <LogoutIcon />
      </Flex>
    </div>
  )
}
